export const BANNER_HEIGHT = {
  /**
   * Floor for compact home and details banners between 600px and 1023px.
   * `0px` outside that range, so `min-height` stays inert at 375 and ≥1024.
   */
  DETAILS_BANNER_COMPACT: '--banner-height-details-banner-compact',
} as const
export type BANNER_HEIGHT = (typeof BANNER_HEIGHT)[keyof typeof BANNER_HEIGHT]
